export const formatDate = (dt: Date) => {
  const months = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december']
  const day = dt.getDate().toString()
  const month = months[(dt.getMonth())]
  return `${day}  ${month} ${dt.getFullYear()}`
}